import React from 'react'
import styled from 'styled-components'
import CalendarRight from './components/CalendarRight'
import LeftText from './components/LeftText'

interface props {
  ctl: boolean
  handleSubmit: Function
}

export default function Calendar({ ctl, handleSubmit }: props) {
  return (
    <Card>
      <LeftText ctl={ctl} />
      <CalendarRight ctl={ctl} handleSubmit={handleSubmit} />
    </Card>
  )
}

const Card = styled.div`
  border-radius: 34px;
  max-width: 1200px;
  min-width: 1200px;
  min-height: 640px;
  border: 1px solid #bdbdbd;
  font-family: Raleway;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 80px;
  text-align: left;
  display: flex;
  @media only screen and (max-width: 600px) {
    max-width: 600px;
    min-width: 200px;
    width: 95%;
    margin-top: 20px;
    flex-direction: column;
  }
`
